import { ImageFromDataState } from '../../../../../cross-team-shared/state/image-from-data-state';

export class SensorRendererState extends ImageFromDataState {
  // All the core team needs to know about each sensor frame is if they are
  // loaded or not.
  constructor(
    public loadedFrames: boolean[],
    height: number,
    width: number,
  ) {
    super(width, height);
  }
}
